import React, { useState, useEffect } from "react";
import SectionWrapper, { Container } from "./aboutGrid.style";
import Fade from "react-reveal/Fade";
import { Link } from "gatsby";

const AboutGrid = () => {
  const [aboutData, setAboutData] = useState(null);
  // const apiUrl = process.env.GATSBY_API_URL;

  useEffect(() => {
    fetch(`https://radianceadmin.manageprojects.in/api/home-aboutus`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setAboutData(data.data[0]);
        }
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);

  if (!aboutData) return <div></div>; // Add loading state

  return (
    <SectionWrapper id="whoWeAre">
      <Container className="myContainerLarge">
        <div className="parentGrid">
          <div className="divGrid1">
            <Fade left>
              <p style={{ color: "#A8600E", marginBottom: "0" }}>{aboutData.sub_heading}</p>
              <h2 style={{ paddingBottom: "35px" }} dangerouslySetInnerHTML={{ __html: aboutData.heading }} />
            </Fade>
          </div>

          <div className="divGrid2">
            <Fade right>
              <img src={`${aboutData.image4_url}`} alt="human hair wigs" />
            </Fade>
          </div>

          <div className="divGrid3">
            <Fade bottom>
              <div style={{ marginTop: "-45px" }}>
                <p dangerouslySetInnerHTML={{ __html: aboutData.about_content }}></p>
                <p className="spaceddText" dangerouslySetInnerHTML={{ __html: aboutData.about_content_two }}></p>

                <div className="flex">
                  <Link to="/about.php" className="btn btn-default">
                    More About Us
                  </Link>
                  <Link
                    to="/gallery.php#gallery-0"
                    className="playVideo"
                    style={{ marginLeft: "20px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="39"
                      viewBox="0 0 39 39"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_25_264)">
                        <path
                          d="M16.2865 27.1306L27.2507 20.5867C27.6476 20.3525 27.866 19.9322 27.866 19.5049C27.866 19.0864 27.653 18.6591 27.2478 18.4226L16.2849 11.8782L16.2809 11.8758C15.9015 11.6517 15.4173 11.6365 15.0154 11.867L15.013 11.8684C14.6242 12.0927 14.3844 12.5091 14.3844 12.9583V19.5049V26.0516C14.3844 26.5032 14.6249 26.9159 15.0097 27.1395C15.4142 27.3756 15.9041 27.3605 16.2865 27.1306ZM1 19.5056C1 9.2891 9.28349 1.00562 19.5 1.00562C29.7164 1.00562 38 9.2891 38 19.5056C38 29.7221 29.7164 38.0056 19.5 38.0056C9.28349 38.0056 1 29.7221 1 19.5056Z"
                          stroke="#A8600E"
                          stroke-width="2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_25_264">
                          <rect
                            width="39"
                            height="39"
                            fill="white"
                            transform="translate(0 0.00561523)"
                          />
                        </clipPath>
                      </defs>
                    </svg>{" "}
                    Play Video
                  </Link>
                </div>
              </div>
            </Fade>
          </div>

          <div className="divGrid4">
            <Fade left>
              <img src={`${aboutData.image1_url}`} alt="men hair wigs" />
            </Fade>
          </div>

          <div className="divGrid5">
            <Fade bottom>
              <img src={`${aboutData.image2_url}`} alt="men hair style" />
            </Fade>
          </div>

          <div className="divGrid6">
            <Fade bottom>
              <img src={`${aboutData.image3_url}`} alt="women face" />
            </Fade>
          </div>

          <div className="divGrid7">
            <Fade right>
              <img src={`${aboutData.image5_url}`} alt="women hair wigs" />
            </Fade>
          </div>
        </div>

        {/* Modal remains unchanged */}
      </Container>
    </SectionWrapper>
  );
};

export default AboutGrid;